import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { IncentiveService } from '../create-incentive/create-incentive.service';
import { ToastMessage } from '../toast-message/toast-message.service';
import { DatePipe } from '@angular/common';
import { ToasterService } from '../toaster.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { LoaderService } from '../loader.service';
import { AlertDialogService } from '../shared/alert-dialog/alert-dialog.service';
import { buildIncentiveApiPayload } from './incentive-payload.builder';
import { AuthzAccessHintService } from '../shared/authz-access-hint/authz-access-hint.service';
import { AuthService } from '../auth.service';
import { applyDuplicateNotEditable, applyEditImmutableContract as applyEditImmutableContractFlags, startOfLocalDay, } from './create-incentive-edit-locks';
var CreateIncentiveComponent = /** @class */ (function () {
    function CreateIncentiveComponent(formBuilder, incentiveService, toastMessage, datePipe, toasterService, router, route, sharedService, loaderService, alertDialogService, authzAccessHintService, authService) {
        this.formBuilder = formBuilder;
        this.incentiveService = incentiveService;
        this.toastMessage = toastMessage;
        this.datePipe = datePipe;
        this.toasterService = toasterService;
        this.router = router;
        this.route = route;
        this.sharedService = sharedService;
        this.loaderService = loaderService;
        this.alertDialogService = alertDialogService;
        this.authzAccessHintService = authzAccessHintService;
        this.authService = authService;
        this.submittingForm = false;
        this.isOptional = false;
        this.incentiveData = {};
        this.defaultValue = {};
        this.formLoaded = false;
        this.state = this.sharedService.STATE.CREATE;
        this.authzAccessHint = null;
        this.NOT_EDITABLE = {
            incentiveName: false,
            selectedSegment: false,
            identifier: false,
            incentiveDisplayName: false,
            selectedIncentive: false,
            selectedCity: false,
            selectedService: false,
            selectedShift: false,
            selectedRule: false,
            fromDate: false,
            toDate: false,
            priority: false,
            variables: false,
            timings: false,
            goals: false,
            weeklyDays: false,
            tnc: false,
            smsTemplate: false,
            isHHIncentive: false,
            isMCIncentive: false,
            selectedMicroCorridorId: false,
            incentiveVersion: false,
            payoutType: false,
            active: false,
        };
    }
    CreateIncentiveComponent.prototype.createFormUpdateRule = function () {
        var _this = this;
        if (this.state === this.sharedService.STATE.DUPLICATE) {
            applyDuplicateNotEditable(this.NOT_EDITABLE);
            return {};
        }
        if (this.state === this.sharedService.STATE.EDIT) {
            this.NOT_EDITABLE.incentiveVersion = true;
            this.NOT_EDITABLE.payoutType = true;
            this.NOT_EDITABLE.isMCIncentive = true;
            this.NOT_EDITABLE.selectedMicroCorridorId = true;
        }
        var startDate = this.defaultValue.startDate;
        if (!startDate) {
            this.applyEditImmutableContract();
            return {};
        }
        var today = startOfLocalDay(new Date());
        var insentiveStartDate = new Date(this.defaultValue.startDate);
        var incentiveStartDay = startOfLocalDay(insentiveStartDate);
        if (this.defaultValue.incentiveType == 'Adhoc') {
            if (this.defaultValue.active)
                Object.keys(this.NOT_EDITABLE).forEach(function (fieldName) {
                    _this.NOT_EDITABLE[fieldName] = true;
                });
            else {
                Object.keys(this.NOT_EDITABLE).forEach(function (fieldName) {
                    _this.NOT_EDITABLE[fieldName] = false;
                });
            }
        }
        else if (this.defaultValue.incentiveType == 'Weekly Fixed') {
            this.NOT_EDITABLE['weeklyDays'] = true;
            this.NOT_EDITABLE['variables'] = true;
            this.NOT_EDITABLE['incentiveName'] = true;
            this.NOT_EDITABLE['selectedIncentive'] = true;
            this.NOT_EDITABLE['selectedShift'] = true;
            this.NOT_EDITABLE['selectedCity'] = true;
            this.NOT_EDITABLE['selectedRule'] = true;
            this.NOT_EDITABLE['selectedService'] = true;
            this.NOT_EDITABLE['fromDate'] = true;
            this.NOT_EDITABLE['priority'] = true;
            this.NOT_EDITABLE['timings'] = true;
        }
        else {
            // Align with captain-incentive: started when startDate <= today (calendar day).
            var notYetStarted = incentiveStartDay.getTime() > today.getTime();
            if (notYetStarted) {
                Object.keys(this.NOT_EDITABLE).forEach(function (fieldName) {
                    _this.NOT_EDITABLE[fieldName] = false;
                });
            }
            else {
                Object.keys(this.NOT_EDITABLE).forEach(function (fieldName) {
                    _this.NOT_EDITABLE[fieldName] = true;
                });
                this.NOT_EDITABLE.toDate = false;
                this.NOT_EDITABLE.active = false;
            }
        }
        this.applyEditImmutableContract();
    };
    /** Started edit: keep SMS fields identical to GET (legacy UI freeze semantics). */
    CreateIncentiveComponent.prototype.readonlySmsSnapshotForEdit = function () {
        if (this.state !== this.sharedService.STATE.EDIT || !this.NOT_EDITABLE.smsTemplate) {
            return undefined;
        }
        var snapshot = this.defaultValue;
        if (!snapshot) {
            return undefined;
        }
        return {
            smsTemplate: snapshot.smsTemplate,
            messageLocale: snapshot.messageLocale,
        };
    };
    /**
     * Version stays locked on edit and duplicate (v1 cannot become v2, and the reverse).
     * On edit, payout type and the MC checkbox stay locked too. The corridor itself stays
     * editable only while the incentive has not started, so a service change can pick a new corridor.
     */
    CreateIncentiveComponent.prototype.applyEditImmutableContract = function () {
        var today = new Date();
        applyEditImmutableContractFlags(this.state, this.sharedService.STATE.EDIT, this.sharedService.STATE.DUPLICATE, this.NOT_EDITABLE, this.defaultValue, today);
    };
    CreateIncentiveComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderService.openLoading();
        this.loadAccessHint();
        var incentiveId = this.route.snapshot.paramMap.get('incentiveId');
        this.incentiveId = incentiveId;
        var action = this.route.snapshot.paramMap.get('action') || this.sharedService.STATE.CREATE;
        switch (action) {
            case 'edit': {
                this.incentiveService.getIncentive(incentiveId)
                    .subscribe(function (res) {
                    _this.defaultValue = res;
                    _this.createFormUpdateRule();
                    _this.formLoaded = true;
                    _this.loaderService.closeLoading();
                });
                this.state = this.sharedService.STATE.EDIT;
                break;
            }
            case this.sharedService.STATE.CREATE: {
                this.formLoaded = true;
                this.loaderService.closeLoading();
                break;
            }
            case this.sharedService.STATE.DUPLICATE: {
                this.incentiveService.getIncentive(incentiveId)
                    .subscribe(function (res) {
                    _this.defaultValue = res;
                    applyDuplicateNotEditable(_this.NOT_EDITABLE);
                    _this.formLoaded = true;
                    _this.loaderService.closeLoading();
                });
                this.state = this.sharedService.STATE.DUPLICATE;
                break;
            }
        }
        this.firstFormGroup = this.formBuilder.group({
            firstCtrl: ['', Validators.required]
        });
        this.secondFormGroup = this.formBuilder.group({
            secondCtrl: ''
        });
    };
    CreateIncentiveComponent.prototype.loadAccessHint = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.authzAccessHintService.getAccessHintData('incentive')];
                    case 1:
                        _a.authzAccessHint = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateIncentiveComponent.prototype.goForward = function (stepper) {
        stepper.next();
    };
    CreateIncentiveComponent.prototype.goBack = function (stepper) {
        stepper.previous();
    };
    CreateIncentiveComponent.prototype.generateUuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    CreateIncentiveComponent.prototype.storeIncentiveInfo = function (event, type) {
        if (!event) {
            return;
        }
        if (this.submittingForm) {
            return;
        }
        this.submittingForm = true;
        if (event.submit === true) {
            this.loaderService.openLoading();
            void this.submitIncentiveWithActor(event);
            return;
        }
        else {
            var info = tslib_1.__assign({}, this.incentiveData);
            info[type] = event;
            this.incentiveData = info;
            this.submittingForm = false;
        }
    };
    CreateIncentiveComponent.prototype.submitIncentiveWithActor = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var actorEmail, user, error_1, incentiveObj;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actorEmail = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.authService.getUserDetails().toPromise()];
                    case 2:
                        user = _a.sent();
                        actorEmail = (user && user.email) ? user.email : '';
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error fetching user details:', error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        incentiveObj = buildIncentiveApiPayload(this.incentiveData, {
                            active: event.active,
                            state: this.state,
                            duplicateState: this.sharedService.STATE.DUPLICATE,
                            editState: this.sharedService.STATE.EDIT,
                            datePipe: this.datePipe,
                            generateUuid: function () { return _this.generateUuid(); },
                            actorEmail: actorEmail,
                            existingPayoutPolicy: this.state === this.sharedService.STATE.EDIT
                                ? this.defaultValue.payoutPolicy
                                : undefined,
                            readonlySmsFromGet: this.readonlySmsSnapshotForEdit(),
                        });
                        switch (this.state) {
                            case this.sharedService.STATE.EDIT: {
                                this.incentiveService.editIncentive(this.incentiveId, incentiveObj).subscribe(function (response) {
                                    if (response) {
                                        _this.toasterService.showToaster(new Toaster({
                                            type: ToasterType.SUCCESS,
                                            message: 'Successfully updated ' + incentiveObj['incentiveType'] + ' incentive',
                                        }));
                                        setTimeout(function () {
                                            _this.submittingForm = false;
                                            _this.router.navigate(['/incentives']);
                                        }, 1000);
                                    }
                                    else {
                                        _this.submittingForm = false;
                                        _this.toasterService.showToaster(new Toaster({
                                            type: ToasterType.WARNING,
                                            message: 'Cannot create ' + incentiveObj['incentiveType'] + ' incentive',
                                        }));
                                    }
                                    _this.loaderService.closeLoading();
                                }, function (error) {
                                    _this.submittingForm = false;
                                    _this.loaderService.closeLoading();
                                    var errBody = error && error.error;
                                    var errMessage = (errBody && errBody.data && errBody.data.message) || (errBody && errBody.message) || '';
                                    if (errMessage === 'INCENTIVE_NOT_EDITABLE') {
                                        _this.alertDialogService.open({
                                            title: 'Incentive not editable',
                                            message: 'Already started incentives can\'t be edited.',
                                            confirmText: 'OK',
                                        });
                                        return;
                                    }
                                    _this.toasterService.showToaster(new Toaster({
                                        type: ToasterType.WARNING,
                                        message: 'Error in creating ' + incentiveObj['incentiveType'] + ' incentive',
                                    }));
                                });
                                break;
                            }
                            case this.sharedService.STATE.DUPLICATE:
                            case this.sharedService.STATE.CREATE: {
                                this.incentiveService.createIncentive(incentiveObj).subscribe(function (response) {
                                    if (response) {
                                        _this.toasterService.showToaster(new Toaster({
                                            type: ToasterType.SUCCESS,
                                            message: 'Successfully created ' + incentiveObj['incentiveType'] + ' incentive',
                                        }));
                                        setTimeout(function () {
                                            _this.submittingForm = false;
                                            _this.router.navigate(['/incentives']);
                                        }, 500);
                                    }
                                    else {
                                        _this.submittingForm = false;
                                        _this.toasterService.showToaster(new Toaster({
                                            type: ToasterType.WARNING,
                                            message: 'Cannot create ' + incentiveObj['incentiveType'] + ' incentive',
                                        }));
                                    }
                                    _this.loaderService.closeLoading();
                                }, function (error) {
                                    _this.submittingForm = false;
                                    _this.loaderService.closeLoading();
                                    _this.toasterService.showToaster(new Toaster({
                                        type: ToasterType.WARNING,
                                        message: 'Error in creating ' + incentiveObj['incentiveType'] + ' incentive',
                                    }));
                                });
                                break;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateIncentiveComponent.prototype.moveStepper = function (event) {
        this.stepper.selectedIndex = event;
    };
    return CreateIncentiveComponent;
}());
export { CreateIncentiveComponent };
